import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/common/routes/requireAuth'
import OrganizationsPageContent from '@/pages/organizations/_components/OrganizationsPageContent'

export const Route = createFileRoute('/app/organizations/')({
  beforeLoad: ({ context }) => {
    requireAuth(context)
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <OrganizationsPageContent />
}
